// Pure helpers for the External Collaborators list's "Department" column.
// Kept framework-free so they can be unit-tested without jsdom.

/** Access-column noun. New grants are Departments; legacy ones are Spaces. */
export function grantNoun(resourceType, plural = false) {
  const base =
    resourceType === 'space'
      ? 'Space'
      : resourceType === 'department'
        ? 'Department'
        : 'grant'
  return plural ? `${base}s` : base
}

/**
 * Department-column label for a collaborator row. Prefer the resolved
 * department name(s). A department grant with no resolvable name means that
 * Department was removed, so show a dash instead of a phantom "1 Department".
 * Legacy space-only grants fall back to a count + noun.
 */
export function grantSummaryLabel(row) {
  const names = row?.grantDepartmentNames
  if (names && names.length > 0) return names.join(', ')
  if (row?.grantResourceType === 'department') return '—'
  const count = row?.grantCount ?? 0
  if (count === 0) return '—'
  return `${count} ${grantNoun(row?.grantResourceType, count !== 1)}`
}
